import { id } from "date-fns/locale";

const basicDataFirstTab = [
  {
    id: 0,
    mainHead: "Basic Assessment Details",
    subHead:
      "Evaluate and improve your environmental, social, and governance performance with our comprehensive assessment tools and customized recommendations.",
  },
];

const basicDataSecondTab = [
  // {
  //   id: 0,
  //   mainHead: "API Connection",
  //   subHead:
  //     "Seamlessly integrate ESG assessment data with your existing systems through our flexible and secure API connection",
  // },
  {
    id: 0,
    mainHead: "Documents",
    subHead:
      "Share your ESG performance with stakeholders and the public by uploading and publishing comprehensive, accurate, and up-to-date reports.",
  },
  {
    id: 1,
    mainHead: "Peer Companies",
    subHead:
      "Share Peers ESG performance with stakeholders and the public by uploading and publishing comprehensive, accurate, and up-to-date reports.",
  },
];

const esgProfileTab = [
  {
    id: 0,
    mainHead: "ESG Profile",
    subHead:
      "Demonstrate your commitment to sustainable business practices by creating and publishing an ESG declaration outlining your company's values, goals, and performance metrics",
  },
  {
    id: 1,
    mainHead: "ESG KPIs",
    subHead:
      "Monitor and analyze media and public sentiment related to your company's ESG practices and address potential controversies in a timely and effective manner.",
  },
  {
    id: 2,
    mainHead: "Peer Analysis",
    subHead:
      "Benchmark your company's ESG performance against peers in your industry and identify best practices to improve your overall sustainability profile.",
  },
];

export { basicDataFirstTab, basicDataSecondTab, esgProfileTab };
